import { ProcessLanguageLevelDto, ProcessRequirementsSectionTypeDto } from '@/api/generated';
import {
  CreateProcessTranslation,
  createProcessTranslation,
} from '@/assets/locales/views/processes/createProcess/createProcess.translation.en.ts';
import {
  processDetailsTranslation,
  ProcessDetailsTranslation,
} from '@/assets/locales/views/processes/details/processDetails.translation.en.ts';
import {
  processListTranslation,
  ProcessListTranslation,
} from '@/assets/locales/views/processes/list/processList.translation.en.ts';

export type ProcessesTranslation = {
  createProcess: CreateProcessTranslation;
  details: ProcessDetailsTranslation;
  form: {
    buttons: {
      back: string;
      close: string;
      next: string;
      save: string;
    };
    languages: {
      addNewLanguage: string;
      infotip: string;
      level: string;
      newLanguagePlaceholder: string;
      tabs: Record<ProcessLanguageLevelDto, string>;
      title: string;
    };
    redFlags: {
      addNewRedFlag: string;
      infotip: string;
      newRedFlagsPlaceholder: string;
      title: string;
    };
    requirements: {
      addNew: string;
      infotip: string;
      newRequirementPlaceholders: {
        [ProcessRequirementsSectionTypeDto.NiceToHave]: string;
        [ProcessRequirementsSectionTypeDto.Required]: string;
      };
      tabs: {
        [ProcessRequirementsSectionTypeDto.NiceToHave]: string;
        [ProcessRequirementsSectionTypeDto.Required]: string;
      };
      title: string;
    };
    title: {
      setProcessLanguages: string;
      setProcessRedFlags: string;
      setProcessRequirements: string;
    };
  };
  list: ProcessListTranslation;
};

export const processesTranslation: ProcessesTranslation = {
  createProcess: createProcessTranslation,
  details: processDetailsTranslation,
  form: {
    buttons: {
      back: 'Back',
      close: 'Close',
      next: 'Next',
      save: 'Save',
    },
    languages: {
      addNewLanguage: 'New Language',
      infotip:
        'Every language is automatically included in AI analysis with the highest weight (W5).',
      level: 'Level',
      newLanguagePlaceholder: 'provide language name',
      tabs: {
        [ProcessLanguageLevelDto.Advanced]: 'Advanced',
        [ProcessLanguageLevelDto.Basic]: 'Basic',
        [ProcessLanguageLevelDto.Intermediate]: 'Intermediate',
        [ProcessLanguageLevelDto.Native]: 'Native',
        [ProcessLanguageLevelDto.Proficient]: 'Proficient',
        [ProcessLanguageLevelDto.Unknown]: 'Unknown',
      },
      title: 'Languages',
    },
    redFlags: {
      addNewRedFlag: 'add new red flag',
      infotip:
        'List the red flags in the field below that should be considered when analyzing the requirements of the process.',
      newRedFlagsPlaceholder: 'write the red flag',
      title: 'Red Flags',
    },
    requirements: {
      addNew: 'Add new',
      infotip:
        'Move the slider from 1 to 5 to assess how important the given issue is in the process.',
      newRequirementPlaceholders: {
        [ProcessRequirementsSectionTypeDto.NiceToHave]: 'write new, nice to have issue',
        [ProcessRequirementsSectionTypeDto.Required]: 'write new, required issue',
      },
      tabs: {
        [ProcessRequirementsSectionTypeDto.NiceToHave]: 'Nice to have',
        [ProcessRequirementsSectionTypeDto.Required]: 'Required',
      },
      title: 'Requirements',
    },
    title: {
      setProcessLanguages: 'Set required languages',
      setProcessRedFlags: 'Set process red flags',
      setProcessRequirements: 'Set process requirements',
    },
  },
  list: processListTranslation,
};
